import React, { useState } from "react";
import "./ManagePartnersDetails.css";
import { useParams, useNavigate } from "react-router-dom";
import LoadingSpinner from "../../../Loading/component";
import Sidebar from "../../../Navigation/Sidebar/Sidebar";
import leftArrow from "../../../../assests/leftArrow.svg";
import bankicon from "../../../../assests/bankicon.svg";
import chargemap from "../../../../assests/chargemap.svg";
import gprofile from "../../../../assests/gprofile.svg";
import cohorts from "../../../../assests/cohorts.svg";
import uid from "../../../../assests/uid.svg";
import vmids from "../../../../assests/vmids.svg";
import { FaTimes, FaBox, FaMapMarkerAlt, FaUser, FaBuilding, FaCreditCard } from "react-icons/fa";

const ManagePartnersDetailsComponent = (props) => {
  const [showAll, setShowAll] = useState(false);
  const maxVisibleItems = 8;
  const { cohortId, franchiseeId } = useParams();
  const navigate = useNavigate();

  const machines = props.cohortDetails?.machines || [];
  const visibleMachines = machines.slice(0, maxVisibleItems);
  const remainingMachines = machines.slice(maxVisibleItems);

  // Function to get franchisee type display name
  const getFranchiseeTypeName = (cohortTypeId) => {
    const typeMapping = {
      2: "FOFO (Franchise)",
      4: "FOCO (City)",
      13: "PDF"
    };
    return typeMapping[cohortTypeId] || "N/A";
  };

  // Get badge class based on type
  const getBadgeClass = (type) => {
    if (type.includes("FOFO")) return "mpd-badge mpd-badge-fofo";
    if (type.includes("FOCO")) return "mpd-badge mpd-badge-foco";
    if (type.includes("PDF")) return "mpd-badge mpd-badge-pdf";
    return "";
  };

  const franchiseeType = getFranchiseeTypeName(props.franchiseeDetails?.cohortTypeId);
  const badgeClass = getBadgeClass(franchiseeType);

  const handleGoBack = () => navigate(-1);
  const editCohortDetails = () => navigate(`/home/updatecohortdetails/${cohortId}`);
  const editFranchiseeDetails = () => navigate(`/home/updatefranchiseedetails/${franchiseeId}`);
  const editBankDetails = () => navigate(`/home/updatebankdetails/${franchiseeId}`);
  const editMapCharges = () => navigate(`/home/updatemapcharges/${franchiseeId}`);
  const addMapCharges = () => navigate(`/home/updatenewmapcharges/${franchiseeId}`);

  return (
    <>
      {props.loading ? (
        <LoadingSpinner />
      ) : (
        <div className="mpd-main-wrapper">
          {/* Sidebar */}
          <div className="mpd-sidebar-container">
            <Sidebar />
          </div>
          
          {/* Main Content */}
          <div className="mpd-content-wrapper">
            {/* Header */}
            <div className="mpd-header">
              <button className="mpd-back-btn" onClick={handleGoBack} aria-label="Go back">
                <img src={leftArrow} alt="Back" />
              </button>
              <h1 className="mpd-title">Manage Partners </h1>
            </div>

            {/* Cohort Section */}
            <div className="mpd-section">
              <div className="mpd-section-header">
                <div className="mpd-section-header-left">
                  <img src={cohorts} alt="" />
                  Cohort: {props.cohortDetails?.name || "N/A"}
                </div>
                <div className="mpd-section-header-right">
                  <button className="mpd-edit-btn" onClick={editCohortDetails}>
                    Edit
                  </button>
                </div>
              </div>

              <div className="mpd-card-grid">
                {/* Area Name Card */}
                <div className="mpd-card">
                  <span className="mpd-card-label">Area Name</span>
                  <div className="mpd-card-value">{props.cohortDetails?.areaName || "N/A"}</div>
                  <div className="mpd-card-row" style={{ marginTop: '8px' }}>
                    <FaMapMarkerAlt style={{ color: '#94a3b8', fontSize: '14px' }} />
                    <p>Lat: {props.cohortDetails?.lat || "N/A"} | Lng: {props.cohortDetails?.lng || "N/A"}</p>
                  </div>
                </div>

                {/* IDs Card */}
                <div className="mpd-card">
                  <span className="mpd-card-label">IDs</span>
                  <div className="mpd-card-row">
                    <img src={uid} alt="" />
                    <p><strong>User ID:</strong> {props.cohortDetails?.id || "N/A"}</p>
                  </div>
                  <div className="mpd-card-row">
                    <img src={cohorts} alt="" />
                    <p><strong>Cohort Type:</strong> {props.cohortDetails?.cohortTypeId || "N/A"}</p>
                  </div>
                </div>

                {/* VM IDs Card - Full Width */}
                <div className="mpd-card mpd-card-full">
                  <div className="mpd-vm-section">
                    <img src={vmids} alt="" />
                    <div className="mpd-vm-list">
                      <span className="mpd-card-label" style={{ marginRight: '8px' }}>VM IDs:</span>
                      {visibleMachines.length > 0 ? (
                        visibleMachines.map((machine, index) => (
                          <span key={machine.id} className="mpd-vm-tag">
                            {machine.id}
                          </span>
                        ))
                      ) : (
                        <span className="mpd-card-value-small">No machines assigned</span>
                      )}
                      {remainingMachines.length > 0 && (
                        <>
                          <span className="mpd-vm-tag" style={{ background: '#f1f5f9', color: '#64748b' }}>
                            +{remainingMachines.length} more
                          </span>
                          <button 
                            className="mpd-vm-more-btn"
                            onClick={() => setShowAll(true)}
                          >
                            View All
                          </button>
                        </>
                      )}
                    </div>
                  </div>
                </div>

                {/* Description Card */}
                <div className="mpd-card mpd-card-full">
                  <span className="mpd-card-label">Description</span>
                  <div className="mpd-card-value-small">
                    {props.cohortDetails?.description || "No description available"}
                  </div>
                </div>
              </div>
            </div>

            {/* Details Section - Franchisee + Bank */}
            <div className="mpd-details-grid">
              {/* Franchisee Section */}
              <div className="mpd-section">
                <div className="mpd-section-header">
                  <div className="mpd-section-header-left">
                    <img src={gprofile} alt="" />
                    Franchise: {props.franchiseeDetails?.name || "N/A"}
                  </div>
                  <div className="mpd-section-header-right">
                    <button className="mpd-edit-btn" onClick={editFranchiseeDetails}>
                      Edit
                    </button>
                  </div>
                </div>

                <div className="mpd-franchisee-cards">
                  <div className="mpd-card">
                    <span className="mpd-card-label">Type</span>
                    <div className="mpd-card-value">
                      <span className={badgeClass}>{franchiseeType}</span>
                    </div>
                    <div className="mpd-card-row" style={{ marginTop: '8px' }}>
                      <FaUser style={{ color: '#94a3b8', fontSize: '14px' }} />
                      <p><strong>Owner:</strong> {props.franchiseeDetails?.owner?.id || "N/A"}</p>
                    </div>
                    <div className="mpd-card-row">
                      <img src={uid} alt="" />
                      <p><strong>Cohort ID:</strong> {props.franchiseeDetails?.cohortId || "N/A"}</p>
                    </div>
                    <div className="mpd-card-row">
                      <FaBuilding style={{ color: '#94a3b8', fontSize: '14px' }} />
                      <p><strong>Warehouse:</strong> {props.franchiseeDetails?.warehouse?.id || "N/A"}</p>
                    </div>
                  </div>

                  <div className="mpd-card">
                    <span className="mpd-card-label">Description</span>
                    <div className="mpd-card-value-small">
                      {props.franchiseeDetails?.description || "No description available"}
                    </div>
                  </div>
                </div>
              </div>

              {/* Bank Section */}
              <div className="mpd-section">
                <div className="mpd-section-header">
                  <div className="mpd-section-header-left">
                    <img src={bankicon} alt="" />
                    Bank Details
                  </div>
                  <div className="mpd-section-header-right">
                    <button className="mpd-edit-btn" onClick={editBankDetails}>
                      Edit
                    </button>
                  </div>
                </div>

                <div className="mpd-card">
                  <div className="mpd-card-row">
                    <FaCreditCard style={{ color: '#94a3b8', fontSize: '14px' }} />
                    <p><strong>Account Name:</strong> {props.franchiseeBankDetails?.accountName || "N/A"}</p>
                  </div>
                  <div className="mpd-card-row">
                    <span className="mpd-card-label">Account ID</span>
                    <div className="mpd-card-value-small">{props.franchiseeBankDetails?.accountId || "N/A"}</div>
                  </div>
                  <div className="mpd-card-row">
                    <span className="mpd-card-label">IFSC Code</span>
                    <div className="mpd-card-value-small">{props.franchiseeBankDetails?.ifsc || "N/A"}</div>
                  </div>
                </div>
              </div>
            </div>

            {/* Charges Section */}
            <div className="mpd-section">
              <div className="mpd-section-header">
                <div className="mpd-section-header-left">
                  <img src={chargemap} alt="" />
                  Charges
                </div>
                <div className="mpd-section-header-right">
                  <button className="mpd-edit-btn" onClick={addMapCharges}>
                    Add
                  </button>
                  <button className="mpd-edit-btn" style={{ borderColor: '#d93025', color: '#d93025' }} onClick={editMapCharges}>
                    Remove
                  </button>
                </div>
              </div>

              <div className="mpd-charges-grid">
                {props.franchiseeCharges?.length > 0 ? (
                  props.franchiseeCharges.map((charge, index) => (
                    <div key={index} className="mpd-charge-card">
                      <div className="mpd-charge-header">
                        <span className="mpd-charge-title">Charge #{index + 1}</span>
                        <span className="mpd-charge-id">ID: {charge.id || "N/A"}</span>
                      </div>
                      <ul className="mpd-charge-list">
                        <li>
                          <span className="mpd-charge-label">Name</span>
                          <span className="mpd-charge-value">{charge.name || "N/A"}</span>
                        </li>
                        <li>
                          <span className="mpd-charge-label">Description</span>
                          <span className="mpd-charge-value">{charge.description || "N/A"}</span>
                        </li>
                        <li>
                          <span className="mpd-charge-label">Type</span>
                          <span className="mpd-charge-value">{charge.chargeType || "N/A"}</span>
                        </li>
                        <li>
                          <span className="mpd-charge-label">Value</span>
                          <span className="mpd-charge-value">₹{charge.value || "N/A"}</span>
                        </li>
                        <li>
                          <span className="mpd-charge-label">Min / Max</span>
                          <span className="mpd-charge-value">{charge.valueMin || "N/A"} / {charge.valueMax || "N/A"}</span>
                        </li>
                      </ul>
                    </div>
                  ))
                ) : (
                  <div className="mpd-no-charges">
                    <div className="mpd-no-charges-icon">💰</div>
                    <h4 className="mpd-no-charges-title">No Charges Added</h4>
                    <p className="mpd-no-charges-subtitle">Click "Add" to create a new charge</p>
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* VM Modal */}
          {showAll && (
            <div className="mpd-modal-overlay" onClick={() => setShowAll(false)}>
              <div className="mpd-modal-content" onClick={(e) => e.stopPropagation()}>
                <h3 className="mpd-modal-title">
                  <FaBox style={{ marginRight: '10px', color: '#14AE78' }} />
                  All VM IDs ({machines.length})
                </h3>
                <div className="mpd-modal-list">
                  {machines.map((machine, index) => (
                    <span key={machine.id} className="mpd-modal-tag">
                      {machine.id}
                    </span>
                  ))}
                </div>
                <button 
                  className="mpd-modal-close-btn"
                  onClick={() => setShowAll(false)}
                >
                  <FaTimes style={{ marginRight: '8px' }} />
                  Close
                </button>
              </div>
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default ManagePartnersDetailsComponent;